import React from "react";
import classNames from "classnames/bind";
import style from "./style.module.css";

export interface IMobileNavProps {
    panelOpen: boolean;
    handleBurgerClick: () => void;
}

export function MobileNav(props: IMobileNavProps) {

    const burgerClass = classNames(
        { [style.burger]: true },
        { [style.active]: props.panelOpen }
    )

    return (
        <header className={style.header}>
            <button
                className={burgerClass}
                onClick={props.handleBurgerClick}
            >
                <div className={style.line} id={style.line1}></div>
                <div className={style.line} id={style.line2}></div>
                <div className={style.line} id={style.line3}></div>
            </button>
        </header>
    )
}